import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Breadcrumbs } from '@/shared/ui/breadcrumbs'

// Панель детали грузится на переходе — не тянем её в стартовый бандл.
const VoiceDetail = lazyRouteComponent(() => import('@/widgets/voice-detail'), 'VoiceDetail')

export const Route = createFileRoute('/voices/$voiceId')({
  component: VoicePage,
})

function VoicePage() {
  const { voiceId } = Route.useParams()
  return (
    <>
      <Breadcrumbs current={voiceId} />
      <VoiceDetail voiceId={voiceId} />
    </>
  )
}
